import { client } from './utils';
import { defaultQuery, formatListResponse } from './utils/helpers';

export const getApplications = (query = defaultQuery) =>
    client.post('/account/application/query', query).then(formatListResponse);
